export default __webpack_public_path__ + "static/media/banner-seguro-multirrisco-mobile.5b2b059e.png";